import { io } from 'socket.io-client';
export var socket = io(process.env.REACT_APP_ARO_WS_URL, {
    transports: ['websocket'],
    withCredentials: true,
    path: '/wss/socket.io'
});
